import $ from 'jquery';

const setNavigation = (MYAPP) => {
  const $openTrg  = $('.gnav-opener'),
    $closeTrg = $('.gnav-close,.gnav-close-2'),
    $menu     = $('.sp-global-header, .sp-global-header-bg');
  $openTrg.on('click', function(evt){
    evt.preventDefault();
    $menu.fadeIn();
  });
  $closeTrg.on('click', function(evt){
    evt.preventDefault();
    $menu.fadeOut();
  });
};

const setRemoveNavigation = (MYAPP) => {
  if (!MYAPP.isMobile && $('.sp-global-header').is(':visible')) {
    $('.gnav-close,.gnav-close-2').trigger('click');
  }
};

const setFixedNavigation = (_scroll) => {
  const $body        = $('body'),
    headerHeight = 100;
  if (headerHeight <= _scroll && _scroll < headerHeight*4) {
    $body.addClass('is-preFixedMenu').removeClass('is-fixedMenu');
  } else if (headerHeight*4 <= _scroll) {
    $body.addClass('is-fixedMenu').removeClass('is-preFixedMenu');
  } else {
    $body.removeClass('is-fixedMenu is-preFixedMenu');
  }
};

module.exports = {
  setNavigation      : setNavigation,
  setRemoveNavigation : setRemoveNavigation,
  setFixedNavigation : setFixedNavigation
};



// WEBPACK FOOTER //
// ./src/js/modules/header.js